import { random } from 'lodash';

interface GetWinnerFromLotProps {
    entries: any[];
    setting: any;
    newColors: any[];
    setWinner: (winners: any[]) => void;
    fsWinnerId?: string;
    winnerIndex: any;
    updateFSMeta: (meta: any) => void;
    visualGroupSize?: number;
}

interface GetWinnerFromLotResult {
    realWinnerIdx: number;
    winnerEntry: any;
}

function getSecureRandomInt(max: number) {
  if (max === 0) return 0;
  if (max <= 0 || !Number.isInteger(max)) {
    throw new Error('max must be a positive integer');
  }
  try {
    const randomIndex = random(0, max);
    return randomIndex;
  } catch (error) {
    return Math.floor(Math.random() * (max + 1));
  }
}

export const getWinnerFromLot = ({
  entries,
  fsWinnerId,
  newColors,
  setting,
  updateFSMeta,
  setWinner,
  winnerIndex,
  visualGroupSize,
}: GetWinnerFromLotProps): GetWinnerFromLotResult | undefined => {
  if (!entries?.length) return;

  const fsWinnerIdx = fsWinnerId ? entries.findIndex((opt) => opt.id === fsWinnerId) : -1;
  const realWinnerIdx = fsWinnerIdx >= 0 ? fsWinnerIdx : getSecureRandomInt(entries.length - 1);

  const winnerEntry = entries[realWinnerIdx];
  const winnerId = winnerEntry?.id;

  const winnerResult = entries.map((option, i) => ({
    ...option,
    data: option.body,
    isWinner: option.id === winnerId,
    color: newColors[i % newColors.length],
    interactionId: setting?.wheelInteractionId ?? '',
    interactionType: setting?.wheelInteractionType ?? '',
    keyword: setting?.wheelKeyword ?? '',
  }));

  setWinner(winnerResult);
  winnerIndex.current = visualGroupSize && visualGroupSize > 1
    ? Math.floor(realWinnerIdx / visualGroupSize)
    : realWinnerIdx;

  updateFSMeta({
    wheel: {
      winnerIndex: realWinnerIdx,
      timestamp: Date.now(),
      winnerId,
    },
  });

  return { realWinnerIdx, winnerEntry };
};
